var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoIdentity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 23,
    viewBox: "0 0 15 23",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9E9E9E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.242 12.36c1.301 0 2.153-2.17 2.353-2.875.1-.353-.05-.707-.401-.807-.35-.1-.702.05-.801.404-.35 1.009-.902 1.968-1.152 1.968-.2 0-.451-.555-.702-1.06-.5-1.11-1.202-2.674-3.104-3.38a3.794 3.794 0 001.302-2.876C9.737 1.666 8.084 0 6.031 0 3.98 0 2.326 1.666 2.326 3.734c0 1.212.55 2.271 1.452 2.978C1.927 7.618.625 9.535.625 11.706c0 1.513.651 2.977 1.753 3.986v5.703c0 .353.3.605.6.605.35 0 .6-.303.6-.605l.001-5.956c0-.202-.1-.353-.2-.504a4.209 4.209 0 01-1.502-3.23c0-2.321 1.852-4.189 4.156-4.189 3.005 0 3.706 1.614 4.356 3.028.451.91.851 1.817 1.853 1.817zM6.033 6.256c-1.351 0-2.453-1.11-2.453-2.473 0-1.362 1.1-2.472 2.453-2.472 1.352 0 2.454 1.11 2.454 2.472 0 1.363-1.102 2.473-2.454 2.473z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 15.591v5.818c0 .345.25.591.5.591.29 0 .5-.296.5-.591V15.59c0-.345-.25-.591-.5-.591s-.5.246-.5.591h0z",
    stroke: "#9E9E9E",
    strokeWidth: 0.3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoIdentity);
export default __webpack_public_path__ + "static/media/ico_identity.00649f9f3c85c23301172539e75e864d.svg";
export { ForwardRef as ReactComponent };